<div class="flex gap-sm diagram-tags">
  @for (tag of tags(); track tag.value) {
    <button
      type="button"
      (click)="selectTag(tag.value)"
      class="text-sm font-medium px-sm py-xs rounded-3xl whitespace-nowrap cursor-pointer"
      [class.bg-warning-100]="tag.value === 'payment_non_technical'"
      [class.text-warning-700]="tag.value === 'payment_non_technical'"
      [class.bg-primary-50]="tag.value === 'payment_technical'"
      [class.text-primary-700]="tag.value === 'payment_technical'"
      [class.bg-neutral-100]="tag.value === ''"
      [class.text-neutral-700]="tag.value === ''"
      [class.border]="tag.active"
      [class.border-2]="tag.active"
      [class.border-primary-500]="
        tag.active && tag.value === 'payment_technical'
      "
      [class.border-warning-500]="
        tag.active && tag.value === 'payment_non_technical'
      "
      [class.border-neutral-500]="tag.active && tag.value === ''">
      {{ tag.label }}
    </button>
  }
</div>
